"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setupMShopEventHandlers = setupMShopEventHandlers;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _constants = require("../constants/constants");
var _checkoutRedirectHandler = require("../utils/checkout-redirect-handler");
var _utils = require("../utils/utils");
var _bwaRedirectFallbackPopup = _interopRequireDefault(require("../components/bwa-redirect-fallback-popup/bwa-redirect-fallback-popup"));
var _katalFunnelEvents = require("./katal-funnel-events");
var mShopCheckoutRedirectUrl = null;
var mShopCartCheckoutId = null;
var returnDetectionInterval = null;
var redirectFallbackTimer = null;
var REDIRECT_FALLBACK_POPUP_VISIBILITY_TIMER = 4000;
function handleReturnFromMShop() {
  return _handleReturnFromMShop.apply(this, arguments);
}
function _handleReturnFromMShop() {
  _handleReturnFromMShop = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee4() {
    var redirectUrl;
    return _regenerator["default"].wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          if (!mShopCheckoutRedirectUrl) {
            _context4.next = 9;
            break;
          }
          window.dispatchEvent(new CustomEvent(_constants.EVENT_TYPE.CUSTOM.BWA_QUICK_CHECKOUT_DISMISS));
          redirectUrl = mShopCheckoutRedirectUrl;
          mShopCheckoutRedirectUrl = null;
          if (redirectFallbackTimer) {
            clearTimeout(redirectFallbackTimer);
            redirectFallbackTimer = null;
          }
          _bwaRedirectFallbackPopup["default"].dismiss();
          sessionStorage.setItem(_constants.SESSION_STORAGE_KEYS.IS_MSHOP_INSTALLED, "true");
          _context4.next = 9;
          return (0, _checkoutRedirectHandler.handleCheckoutValidationAndRedirect)(mShopCartCheckoutId, redirectUrl);
        case 9:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return _handleReturnFromMShop.apply(this, arguments);
}
function handleRedirectAttempt(event) {
  var checkoutUrl = event.data.checkoutUrl;
  redirectFallbackTimer = setTimeout(function () {
    // Timer fired => the redirect/app-switch did NOT take the shopper away within the
    // window => stalled. This is the client-side "intent didn't redirect" signal.
    (0, _katalFunnelEvents.logFunnelEvent)(_katalFunnelEvents.FUNNEL_EVENTS.MANDATE_REDIRECT_STALLED, {
      checkoutId: mShopCartCheckoutId
    });
    showRedirectFallbackPopup(checkoutUrl);
  }, REDIRECT_FALLBACK_POPUP_VISIBILITY_TIMER);
  var clearTimer = function clearTimer() {
    if (redirectFallbackTimer) {
      clearTimeout(redirectFallbackTimer);
      redirectFallbackTimer = null;
    }
  };
  window.addEventListener('pagehide', clearTimer, {
    once: true
  });
}
function showRedirectFallbackPopup(checkoutUrl) {
  new _bwaRedirectFallbackPopup["default"](checkoutUrl, mShopCartCheckoutId);
}
function setupMShopEventListener() {
  window.addEventListener(_constants.EVENT_TYPE.MESSAGE, /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2(event) {
      var _event$data, _event$data6, _event$data2, _event$data3, validWidgetIds, _event$data4, _event$data5;
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            try {
              if (((_event$data = event.data) === null || _event$data === void 0 ? void 0 : _event$data.type) === _constants.EVENT_TYPE.CUSTOM.BWA_APP_SWITCH_INITIATED) {
                validWidgetIds = [_constants.CHECKOUT_BUTTON_WITH_ADDRESS_PREFILL_ID, _constants.QUICK_CHECKOUT_SELECT_ANOTHER_ADDRESS_ID, _constants.EMBEDDED_CHECKOUT_IMPORT_ADDRESS_WIDGET_ID];
                if (validWidgetIds.includes((_event$data2 = event.data) === null || _event$data2 === void 0 ? void 0 : _event$data2.widgetId) && (_event$data3 = event.data) !== null && _event$data3 !== void 0 && _event$data3.redirectUrl) {
                  mShopCartCheckoutId = (_event$data4 = event.data) === null || _event$data4 === void 0 ? void 0 : _event$data4.checkoutId;
                  mShopCheckoutRedirectUrl = (_event$data5 = event.data) === null || _event$data5 === void 0 ? void 0 : _event$data5.redirectUrl;
                  if ((0, _utils.isAndroid)() && !(0, _utils.isMetaBrowser)()) {
                    if (returnDetectionInterval) clearInterval(returnDetectionInterval);
                    setTimeout(function () {
                      returnDetectionInterval = setInterval(/*#__PURE__*/(0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
                        return _regenerator["default"].wrap(function _callee$(_context) {
                          while (1) switch (_context.prev = _context.next) {
                            case 0:
                              if (!document.hasFocus()) {
                                _context.next = 4;
                                break;
                              }
                              clearInterval(returnDetectionInterval);
                              _context.next = 4;
                              return handleReturnFromMShop();
                            case 4:
                            case "end":
                              return _context.stop();
                          }
                        }, _callee);
                      })), 500);
                    }, 4500);
                  }
                }
              } else if (((_event$data6 = event.data) === null || _event$data6 === void 0 ? void 0 : _event$data6.type) === _constants.EVENT_TYPE.CUSTOM.BWA_REDIRECT_ATTEMPT) {
                handleRedirectAttempt(event);
              }
            } catch (error) {
              console.error('[BwA] Error handling message event:', error);
            }
          case 1:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }());
}
function setupVisibilityChangeHandler() {
  document.addEventListener(_constants.EVENT_TYPE.VISIBILITY_CHANGE, /*#__PURE__*/(0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3() {
    return _regenerator["default"].wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          if (!(!document.hidden && mShopCheckoutRedirectUrl)) {
            _context3.next = 3;
            break;
          }
          _context3.next = 3;
          return handleReturnFromMShop();
        case 3:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  })));
}
function setupMShopEventHandlers() {
  setupMShopEventListener();
  setupVisibilityChangeHandler();
}
//# sourceMappingURL=mshop-event-handler.js.map
